<template>
  <div>
    <v-layout row>
      <v-btn flat color="buttontext" @click="version">Version</v-btn>
      <v-btn flat color="buttontext" @click="getimage">Get latest</v-btn>
    </v-layout>
    <v-layout row>
      <v-text-field label="image_id" :value="img_id"></v-text-field>
    </v-layout>
    <v-layout row>
      <p>My image</p>
      
    </v-layout>
    <v-img :src="img_img"  contain  height=100> </v-img>
    <v-textarea
      cols="80"
      label="This is a textarea"
      box
      auto-grow
      flat
      clear-icon
      clearable
      :value="textv"
    ></v-textarea>
  </div>
</template>
<script>
// import axios from "axios";
import axios from "axios";

export default {
  data: () => ({
    textv: "Hello World!",
    img_id: 0,
    img_img: "https://pad.hajeka.com/gpad/_data/i/gpad/upload/2019/05/08/20190508121139-069e2f97-sq.jpg"
  }),

  methods: {
    version: function() {
      this.textv = "Getting version...";
      if (process.env.NODE_ENV == "development") {
        var url = "/ws.php?format=json&method=pwg.getVersion";
      } else {
        var url =
          "https://pad.hajeka.com/ws.php?format=json&method=pwg.getVersion";
      }

      axios
        .get(url)
        .then(response => {
          this.textv =
            "Piwigo version: " +
            response.data.result +
            "/" +
            process.env.NODE_ENV;
          // console.log("Response" + response);
        })
        .catch(e => {
          this.textv = e + "\n" + "Still working on that :(";
        });
    },
    getimage: function() {
      this.textv = "Getting image...";
      var url =
        "/ws.php?format=json&method=pwg.categories.getImages&f_min_date_created=2019-05-07";
      if (process.env.NODE_ENV != "development") {
        url = "https://pad.hajeka.com" + url;
      }

      axios
        .get(url)
        .then(response => {
                    this.textv = JSON.stringify(response.data.result);
          this.img_id = response.data.result.images[0].id;
          var isrc = response.data.result.images[0].derivatives['square'].url;
          this.img_img = isrc.replace("https://grafie:8080","");
          console.log("Response" + this.img_img);
        })
        .catch(e => {
          this.textv = e + "\n" + "Still working on that :(";
        });
    }
  }
  // mounted() {
  //   this.version();
  // }
};
</script>